<div class="card shadow-sm rounded-3">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="fw-bold text-dark m-0 d-flex align-items-center">
            <i class="las la-file-invoice me-2"></i> {{ 'MENU.INVOICES' | translate }}
          </h4>
        </div>
        <p class="text-muted mt-2 mb-0">{{ 'APARTMENT.PAYMENTS_DESCRIPTION' | translate }}</p>
      </div>
      <div>
        <button (click)="createInvoice(apartmentId)" class="btn btn-primary btn-sm py-2">
          <i class="las la-plus me-1"></i> {{ 'INVOICES.CREATE_INVOICE' | translate }}
        </button>
      </div>
    </div>
    <div class="mt-4">
      <p-table
        [hasList]="service.hasList"
        (add)="onAdd()"
        (delete)="onDelete($event)"
        (edit)="onEdit($event)"
        (onLazyLoad)="loadData($event)"
        (onPage)="pageChange($event)"
        (view)="onView($event)"
        [columns]="service.tableColumns"
        [dataKey]="'id'"
        [first]="first"
        [globalSearch]="globalSearch"
        [hasActions]="false"
        [hasAdd]="false"
        [hasDelete]="false"
        [hasEdit]="false"
        [hasView]="false"
        [loading]="loading()"
        [rows]="rows"
        [selectionMode]="'single'"
        [title]="service.title"
        [totalRecords]="total"
        [value]="list"
        paginatorPosition="bottom"
        tableStyleClass="table table-hover custom-table"
      >
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="service.tableColumns.length">
              <p class="text-muted mb-0 text-center">
                <i class="las la-search-minus"></i>
                {{ 'RESIDENTS.NO_INVOICE' | translate }}
              </p>
            </td>
          </tr>
        </ng-template>
        <ng-template #cells let-data>
          @for (col of service.tableColumns; track col) {
            @switch (col.fieldName) {
              @case('invoiceDate'){
                <td>
                  {{data.invoiceDate|date:'YYYY-MM-dd'}}
                </td>
              } @case('dueDate'){
                <td>
                  {{data.dueDate|date:'YYYY-MM-dd'}}
                </td>
              }
              @case ('paymentStatus'){
                <td>
                  <span invoicePaymentStatusBadge [status]="data.paymentStatus"></span>
                </td>
              }
              @case('status') {
                <td>
                  <span invoiceStatusBadge [status]="data.status"></span>
                </td>
              }
              @case ('actions') {
                <td>
                  <button
                    class="btn btn-sm btn-primary"
                    [disabled]="!data || data.paymentStatus === InvoicePaymentStatus.PAID"
                    (click)="onPay(data)">
                    <i class="las  la-money-check-alt fs-18 align-middle me-2"></i>
                    {{ 'PAYMENT.PAYMENT' | translate }}
                  </button>
                </td>
              }
              @case ('paymentStatus') {
                <td>
                  <span class="text-white p-1 rounded fs-12 fw-bolder text-uppercase" [class]="'bg-' + paymentStatusBadgeColors[data.paymentStatus]">
                    {{ 'INVOICES.PAYMENT_STATUSES.' + invoicePaymentStatusMapper[data.paymentStatus] | translate }}
                  </span>
                </td>
              }
              @case ('status') {
                <td>
                  <span class="text-white p-1 rounded fs-12 fw-bolder text-uppercase" [class]="'bg-' + statusBadgeColors[data.status]">
                    {{ 'INVOICES.STATUSES.' + invoiceStatusMapper[data.status] | translate }}
                  </span>
                </td>
              }
              @default {
                <td>
                  <p-table-cell-value [data]="data" [column]="col"></p-table-cell-value>
                </td>
              }
            }
          }
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
